"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");require("core-js/modules/es.array.includes");require("core-js/modules/es.string.includes");exports.__esModule = true;exports.default = void 0;var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _EventEmitter2 = _interopRequireDefault(require("../../EventEmitter"));

var _is = require("../../is");
var _TimeDate = _interopRequireDefault(require("../TimeDate"));
var _convert = _interopRequireDefault(require("../convert"));
var _consts = _interopRequireDefault(require("../consts"));

var _utils = require("./utils");



var _innerUtils = require("../innerUtils");var






TimeInputs = /*#__PURE__*/function (_EventEmitter) {(0, _inheritsLoose2.default)(TimeInputs, _EventEmitter);






  function TimeInputs(arg) {var _this;
    _this = _EventEmitter.call(this) || this;(0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "inputed", (0, _innerUtils.nullableDateObj)());(0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "maxObj", (0, _innerUtils.nullableDateObj)());(0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "minObj", (0, _innerUtils.nullableDateObj)());(0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "td", void 0);(0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hasSegments", void 0);
    var opts = (0, _utils.prepareArgs)(arg);
    _this.td = _TimeDate.default.from(opts.date);
    _this.hasSegments = opts.hasSegments;
    if (opts.hasDate) {
      _this._fillInputed();
    }return _this;
  }TimeInputs.



  from = function from(arg) {
    return new TimeInputs(arg);
  };var _proto = TimeInputs.prototype;_proto.

  _emitChange = function _emitChange() {
    // if ( isStr( partName ) ) {
    //   this.emit( `change:${partName}`, {
    //     date: this.date,
    //     partName,
    //     partValue: this.get( partName ),
    //   } )
    // } else {
    //   this.emit( 'change', { date: this.date } )
    // }
    this.emit('change', this._getDataForOnChangeCb());
    // console.log( 'change', this._getDataForOnChangeCb() )
  };_proto.


  _getDataForOnChangeCb = function _getDataForOnChangeCb() {var
    isFilled = this.isFilled;
    var value = !isFilled ?
    { isFilled: isFilled } :
    {
      isFilled: isFilled,
      date: this.td.date,
      ts: this.td.ts,
      seconds: this.td.tsInSec };


    return {
      inputed: (0, _innerUtils.cloneDateObj)(this.inputed),
      max: this.maxObj,
      min: this.minObj,
      value: value,
      daysInMonth: this.daysInMonth };

  };_proto.


  _fillInputed = function _fillInputed() {
    (0, _innerUtils.fillDateObj)(this.inputed, this.td.date, this.hasSegments);
  };_proto.


  setPart = function setPart(partName, valIn) {var
    hasSegments = this.hasSegments;

    var isDatePart = _consts.default.dmyKeys.includes(partName);
    var partSegment = isDatePart ? 'date' : 'time';


    if (
    !hasSegments.date && isDatePart ||
    !hasSegments.time && (partName === 'h' || partName === 'm') ||
    !hasSegments.seconds && partName === 's')
    {
      console.warn("partName (" +
      partName + ") for TimeInputs.setPart is not avalible for selected segments: ",
      this.hasSegments);

      return;
    }

    var val = valIn;
    if (!(0, _is.isNum)(val)) {
      // $FlowFixMe
      this.inputed[partSegment][partName] = null;
      this._calcMinMax();
      this._emitChange();
      return;
    }

    // $FlowFixMe
    var max = this.maxObj[partSegment][partName];
    // $FlowFixMe
    var min = this.minObj[partSegment][partName];

    if ((0, _is.isNum)(max) && val > max) {val = max;}
    if ((0, _is.isNum)(min) && val < min) {val = min;}

    if (val === (0, _innerUtils.getFromDateObj)(this.inputed, partName)) return;

    this.inputed[partSegment][partName] = val;

    this.td.setPart(partName, val);

    if (partName === 'M') {var
      d = this.inputed.date.d;
      if (!(0, _is.isNull)(d)) {
        this.inputed.date.d = this.td.get('d');
      }
    }


    if (this.isFilled) {
      this._fillInputed();
    }

    this._calcMinMax();
    this._emitChange();
  };_proto.


  setSecondsInDay = function setSecondsInDay(seconds) {
    var hms = _convert.default.secToHms(seconds);
    this.td.setParts(hms);
    this._fillInputed();
    this._calcMinMax();
    this._emitChange();
  };_proto.



  _setDate = function _setDate(date) {
    if (!(0, _is.isNull)(date)) {
      this.td.setDate(date);
      this._fillInputed();
    } else {
      (0, _innerUtils.clearDateObj)(this.inputed);
    }
    this._calcMinMax();
  };_proto.

  setDate = function setDate(date) {
    this._setDate(date);
    this._emitChange();
  };_proto.

  setDateWithoutFiringEvent = function setDateWithoutFiringEvent(date) {
    this._setDate(date);
    return this._getDataForOnChangeCb();
  };_proto.





















































  _calcMinMax = function _calcMinMax() {var
    min = this.min,max = this.max;

    if ((0, _is.isNull)(min)) {
      (0, _innerUtils.clearDateObj)(this.minObj);
    } else {
      (0, _utils.calcMinMaxObj)(
      this.inputed,
      this.td.minObj,
      this.minObj,
      this.hasSegments);

    }

    if ((0, _is.isNull)(max)) {
      (0, _innerUtils.clearDateObj)(this.maxObj);
    } else {
      (0, _utils.calcMinMaxObj)(
      this.inputed,
      this.td.maxObj,
      this.maxObj,
      this.hasSegments);

    }
  };_proto.



  destroy = function destroy() {
    this.td.destroy();
    this.off();
  };(0, _createClass2.default)(TimeInputs, [{ key: "isFilled", get: function get() {return (0, _utils.checkIsFilled)(this.inputed, this.hasSegments);} }, { key: "min", get: function get() {return this.td.min;}, set: function set(arg) {var currentMin = this.min;this.td.min = arg;var newMin = this.min;if (currentMin === newMin) return;if (newMin === null) {(0, _innerUtils.clearDateObj)(this.minObj);this._emitChange();return;}this._calcMinMax();this._emitChange();} }, { key: "max", get: function get() {return this.td.max;}, set: function set(arg) {var currentMax = this.max;this.td.max = arg;var newMax = this.max;if (currentMax === newMax) return;if (newMax === null) {(0, _innerUtils.clearDateObj)(this.maxObj);this._emitChange();return;}this._calcMinMax();this._emitChange();} }, { key: "daysInMonth", get: function get() {if ((0, _is.isNull)(this.inputed.date.M)) {return 31;}return this.td.lastDateInMonth;} }]);return TimeInputs;}(_EventEmitter2.default);var _default =





TimeInputs;exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Time/TimeInputs/index.js
// module id = 623
// module chunks = 0